import TransitApi from './base'

export default {
  // TODO: Add search, filters and sort params
  async getAll(params = {}) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString({
        sortBy: 'name',
        sort: 'ASC',
        ...params,
      })
      const result = await Api.get(`/laboratory/list?${queryString}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async getById(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get(`/laboratory/details/${params.id}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async save(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const path = params.id
        ? `/laboratory/details/${params.id}`
        : '/laboratory/add'
      const result = await Api.post(path, params)
      return result
    } catch (error) {
      return error.response
    }
  },

  async delete(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.delete(`/laboratory/${params.id}`)
      return result
    } catch (error) {
      return error.response
    }
  },
}
